import { HideInAppBrowser } from '../../functional/HideInAppBrowser';
import { Spacer } from '../../parts/Spacer';
import { Footer } from './Footer';
import { Header } from './Header';
import { SideNavigation } from './SideNavigation';
import type { Config } from 'u-next/config';

export const BasicLayout: React.FC<
  React.PropsWithChildren<{
    options: Config;
    hasRakutenBanner?: boolean;
  }>
> = ({ children, options, hasRakutenBanner = false }) => (
  <>
    <div className="grid min-h-full grid-cols-1 grid-rows-[auto_1fr_auto]">
      <div className="sticky top-0 z-[100]">
        <HideInAppBrowser>
          <Header options={options} />
        </HideInAppBrowser>
      </div>
      <div className="relative">{children}</div>
      <div>
        <HideInAppBrowser>
          <Spacer spacing={16} />
          <Footer hasRakutenBanner={hasRakutenBanner} config={options} />
        </HideInAppBrowser>
      </div>
    </div>
    <SideNavigation options={options} />
  </>
);
